import { render, staticRenderFns } from "./GalleryRelease.vue?vue&type=template&id=7b4bfc4e&"
import script from "./GalleryRelease.vue?vue&type=script&lang=js&"
export * from "./GalleryRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports